import React from 'react';
import ActionAreaHeader from './header/header.jsx';
import ProductsAndWidgets from './products/products.jsx';

const ActionArea = ({ changeMeasure, onChangeNotApplyTo, changeRoundSettings }) => (
  <div style={{ backgroundColor: '#fafafa', width: '45%', display: 'inline-block', height: '500px', borderBottom: 'solid 1px #eeeeee' }}>
    <div style={{ height: '450px', overflowY: 'scroll' }}>
      <ActionAreaHeader changeMeasure={changeMeasure} changeRoundSettings={changeRoundSettings} />
      <ProductsAndWidgets onChangeNotApplyTo={onChangeNotApplyTo} />
    </div>
  </div>
);

export default ActionArea;



// WEBPACK FOOTER //
// ./src/app/components/contracting/mass-rate-change/middle-action-area/action-area.jsx